export default "__VITE_ASSET__DVMFJDpQ__"